/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon24Solid = forwardRef('DataChartBarsAUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19 3.875c.621 0 1.125.504 1.125 1.125v15a1.125 1.125 0 0 1-2.25 0V5c0-.621.504-1.125 1.125-1.125Z" }),
        React.createElement("path", { d: "M15.125 8.5a1.125 1.125 0 0 0-2.25 0V20a1.125 1.125 0 0 0 2.25 0V8.5Z" }),
        React.createElement("path", { d: "M5.125 15.5a1.125 1.125 0 0 0-2.25 0V20a1.125 1.125 0 0 0 2.25 0v-4.5Z" }),
        React.createElement("path", { d: "M10.125 12a1.125 1.125 0 0 0-2.25 0v8a1.125 1.125 0 0 0 2.25 0v-8Z" })));
});
